import { render, staticRenderFns } from "./PageComponentForm.vue?vue&type=template&id=1edbb4af&"
import script from "./PageComponentForm.vue?vue&type=script&lang=js&"
export * from "./PageComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports